import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["emailInput", "noEmailInput", "noEmailMessage", "emailMessage"]

    static values = {
        currentEmail: String,
        slug: String
    }

    connect() {
        this.previousEmail = this.hasEmailInputTarget ? this.emailInputTarget.value : ""
        this.setEmail()
    }

    setEmail() {
        if (!this.hasNoEmailInputTarget || !this.hasEmailInputTarget) return

        const checked = this.noEmailInputTarget.checked
        const emailInput = this.emailInputTarget

        if (checked) {
            this.previousEmail = emailInput.value
            emailInput.value = `${this.slugValue}@ukcil.com`
            emailInput.readOnly = true
            emailInput.classList.add("bg-gray-100", "cursor-not-allowed")
        } else {
            emailInput.value = this.previousEmail || this.currentEmailValue || ""
            emailInput.readOnly = false
            emailInput.classList.remove("bg-gray-100", "cursor-not-allowed")
        }

        if (this.hasNoEmailMessageTarget) {
            this.noEmailMessageTarget.hidden = !checked
        }

        if (this.hasEmailMessageTarget) {
            this.emailMessageTarget.hidden = checked
        }
    }
}